import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type HelpSolidIconProps = IconProps;

export const HelpSolidIcon = forwardRef<SVGSVGElement, HelpSolidIconProps>(
  function HelpSolidIcon(props: HelpSolidIconProps, ref) {
    return (
      <Icon
        data-testid="HelpSolidIcon"
        aria-label="help solid"
        viewBox="0 0 12 12"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          d="M12 0v12H0V0h12ZM6.082 2.25a2.695 2.695 0 0 1 .832.129c.125.047.242.101.352.164.117.062.222.133.316.21.094.087.176.18.246.282.078.102.145.211.2.328.054.125.093.258.117.399.03.133.046.281.046.445 0 .11-.007.211-.023.305-.016.093-.04.183-.07.27a2.33 2.33 0 0 1-.106.245c-.039.07-.082.141-.129.211L7.7 5.45a2.122 2.122 0 0 1-.187.188c-.063.07-.13.14-.2.21-.07.063-.14.13-.21.2-.047.039-.09.078-.13.117a1.43 1.43 0 0 1-.117.106 1.279 1.279 0 0 0-.093.105 1.233 1.233 0 0 0-.07.105.459.459 0 0 0-.06.106.622.622 0 0 0-.034.129 6.605 6.605 0 0 0-.024.152v.551H5.367v-.75l.024-.176a.927.927 0 0 1 .093-.281l.07-.117c.032-.04.067-.078.106-.117a8.39 8.39 0 0 1 .106-.13l.14-.14.774-.785a.807.807 0 0 0 .187-.281c.04-.11.059-.23.059-.364a.83.83 0 0 0-.07-.351.863.863 0 0 0-.176-.293.863.863 0 0 0-.293-.176.883.883 0 0 0-.352-.07c-.14 0-.27.027-.387.082a.823.823 0 0 0-.304.21c-.094.094-.168.2-.223.317a1.467 1.467 0 0 0-.094.375L3.75 4.277c.023-.164.055-.316.094-.457A2.055 2.055 0 0 1 4.5 2.777c.102-.086.21-.16.328-.222a1.61 1.61 0 0 1 .375-.164 2.43 2.43 0 0 1 .41-.106c.149-.023.305-.035.469-.035Zm-.117 5.777c.11 0 .21.02.305.059.093.039.18.094.257.164a.797.797 0 0 1 .176.258c.047.086.07.18.07.281 0 .11-.02.211-.058.305a.844.844 0 0 1-.445.422.784.784 0 0 1-.305.058c-.047 0-.098-.004-.152-.011a3.703 3.703 0 0 0-.153-.047l-.14-.07a1.279 1.279 0 0 1-.106-.094.673.673 0 0 1-.105-.106.719.719 0 0 1-.07-.129 1.073 1.073 0 0 1-.06-.14 1.159 1.159 0 0 1-.011-.165.7.7 0 0 1 .059-.292.797.797 0 0 1 .175-.258.797.797 0 0 1 .258-.176.784.784 0 0 1 .305-.059Z"
          clipRule="evenodd"
        />
      </Icon>
    );
  }
);
